import * as React from 'react';
import { Text } from '@lightspeed/flame/Text';

import { ItemTd } from './ReceiptItem.style';

interface ReceiptItemQuantityProps {
  quantity: number;
  lineNumber: number;
  isGroupedItemHead: boolean;
  isGroupedItem: boolean;
}

const ReceiptItemQuantity: React.FunctionComponent<ReceiptItemQuantityProps> = ({
  quantity,
  lineNumber,
  isGroupedItem,
}) => {
  return (
    <ItemTd
      isGroupedItem={isGroupedItem}
      as="td"
      pl={3}
      pr={4}
      style={{ textAlign: 'left', verticalAlign: 'baseline' }}
    >
      <Text lineHeight="normal" size="large" data-testid={`saleLine-${lineNumber}-unitQuantity`}>
        {quantity}
      </Text>
    </ItemTd>
  );
};

export { ReceiptItemQuantity };
